import type { Project } from "../../types/project";

export const teamTaskManager: Project = {
  id: "team-task-manager",
  title: "Team Task Manager",
  description:
    "Production-ready MERN project management platform featuring RBAC, analytics dashboards, task assignment workflows, and team collaboration.",
  techStack: ["React", "Node.js", "Express.js", "MongoDB", "JWT", "RBAC"],
  githubUrl: "https://github.com/thvvamshi/team-task-manager",
  liveUrl: "https://team-task-manager-production-7391.up.railway.app/",
  image:
    "https://opengraph.githubassets.com/c9a5f1800001680b6403158b00f5dbfb59bda550b6e8bb7c0b4ecb20c279e10c/thvvamshi/team-task-manager",
  featured: true,
  category: "Full Stack",
  highlights: [
    "Role-aware project workflows",
    "Analytics dashboards for team visibility",
    "Production-oriented MERN architecture",
  ],
};
